import React,{ useState, useEffect, useCallback } from 'react'
import { useSelector, connect } from 'react-redux';
import { Divider, Toggle, Loader, Modal, Button } from 'rsuite';
import { Helmet } from 'react-helmet-async';
import * as actionsPolicy  from '../../../../app/actions/policy';
import { CheckBoxCustom } from '../elements/inputFields';
import { NuInsInputTextLabel, NuInsInputNumInfoLabel } from '../elements/inputFieldsLabel';
import { InfoIcon } from '../svg/iconsSvg';


const InitialDataView = ({onSubmit, loading, noRegData, onConfirm, updateRegProps, updateInitialData}) => {

    const auth = useSelector(state => state.auth);

    const insVehicleInfo = useSelector(state => state.insVehicleInfo);
    const { initialData } = insVehicleInfo;
    const {registered, plate, talon, acceptedCondition} = initialData || {};

    const [formValid,setFormValid] = useState(false)
    const [showCondition, setShowCondition] = useState(false);
    const [showConfidentiality, setShowConfidentiality] = useState(false);
    const [showClientInformmation, setShowClientInformation] = useState(false);

    const validateFields = useCallback(() => {
            if(registered) {
                if(plate && (talon && talon.length > 8 ) && acceptedCondition) {
                    setFormValid(true);
                    return;
                }
            } else {
                if(acceptedCondition) {
                    setFormValid(true);
                    return;
                }
            }

            setFormValid(false);
        }, [plate, talon, acceptedCondition, registered]
    );

    useEffect(() => {
        validateFields();

        if(registered === undefined) {
            updateInitialData({...initialData, registered: true});
        }

    }, [validateFields, registered, initialData, updateInitialData]);

    const onChangeHandler = (field, data) => {
        switch (field) {
            case 'registered':
                    if(data) return updateInitialData({...initialData, registered: data});

                    return updateInitialData({...initialData, registered: data, plate: null, talon: null});
            case 'plate':
                data = data ? data.toUpperCase() : data;
                return updateInitialData({...initialData, plate: data});
            case 'talon':
                return updateInitialData({...initialData, talon: data});
            case 'acceptedCondition':
                return updateInitialData({...initialData, acceptedCondition: data});
            default:
                return 'Unknown stepIndex';
        }
    }

    const submitHandler = (event) => {
        event.preventDefault()
        const data = { plate , talon, registered, acceptedCondition};
        //console.log(data);

        updateRegProps({});

        onSubmit(data);
    }

    const getDefaultChecked = () => {
        return registered === undefined ? true : registered;
    }

    return (
        <div className="steps_container" >
            <Helmet>
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            </Helmet>
            <h6 className="header-main">ГРАЖДАНСКА ОТГОВОРНОСТ</h6>
            <Divider />
            <h6 className="header-main" style={{marginBottom: '36px'}}>3 СТЪПКИ ДО ОФЕРТА ЗА ТВОЕТО МПС</h6>                

            <p className="header-secondary" style={{marginBottom: '20px'}}>Превозното средство е регистрирано в КАТ</p>           
            <div className="steps_container-form show-loading" >
                <Toggle arial-label="Switch" className="align-center" size="lg"  style={{marginBottom: '20px'}}
                        defaultChecked={getDefaultChecked()}
                        checkedChildren=" Да " unCheckedChildren=" Не "
                        onChange={(data) => onChangeHandler('registered', data)} />
                {registered
                    ? <>
                        <NuInsInputTextLabel validationType={"plate"} onChange={(data) => onChangeHandler('plate', data)}  
                             placeholder={"Регистрационен номер на МПС"} value={plate} styles={{marginBottom: '20px'}}/>
                        
                        <NuInsInputNumInfoLabel onChange={(data) => onChangeHandler('talon', data)} 
                            placeholder={"Номер на талон"} value={talon} slice={9} styles={{marginBottom: '20px'}}/> 
                    </>
                    : null
                }                     
              
                
                <div className="steps_container-checkbox">
                    <CheckBoxCustom onChange={(data) => onChangeHandler('acceptedCondition', data)} value={acceptedCondition}/>
                    <div>Приемам&nbsp;
                        <span className="link-pdf" onClick={()=>setShowCondition(true)}>Общите условия</span> на услугата и се запознах с&nbsp; 
                        <span onClick={()=>setShowConfidentiality(true)} className="link-pdf">Уведомлението за поверителност,</span><span>&nbsp;</span>
                        <span onClick={()=>setShowClientInformation(true)} className="link-pdf">Информация за потребителя по чл. 325 от КЗ</span>
                    </div>
                </div>
                <Divider />
                <div className="steps_container-checkbox">
                    <InfoIcon size="38" style={{marginLeft: '2px'}}/>
                    <div>Регистриран застрахователен брокер с удостоверение No 874-ЗБ / 16.05.2023 г., издадено от КФН</div>
                </div>
                <Divider />

                <button className="nuIns-btn nuIns-btn-main nuIns-btn-mxd" type="submit" disabled={!formValid} onClick={submitHandler}>{auth?.loginToken ? 'Започни' : 'Към оферти без профил'}</button>
     
            </div>
            {loading ? <Loader backdrop center size="lg"  speed="slow" /> : null}

            <Modal size="xs" className="nuins-ok-modal" show={noRegData} onHide={() => onConfirm()}>
                <Modal.Body>
                    <p className="no-reg-data">Въведеният регистрационен номер и/или номер на талон е грешен. Провери въведените данни</p>    
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => onConfirm()} >OK</Button>
                </Modal.Footer>
            </Modal>
            <Modal size="sm" show={showCondition || showConfidentiality || showClientInformmation} onHide={() => {setShowCondition(false); setShowConfidentiality(false); setShowClientInformation(false)}}>
                <Modal.Header> </Modal.Header>
                <Modal.Body>
                    <iframe src={showCondition 
                        ?  "/files/Obshti-usloviya.pdf" 
                        : showConfidentiality
                        ? "/files/Uvedomlenie-za-poveritelnost.pdf" 
                        : "/files/Informatsiya-za-potrebitelya.pdf"}  
                            style={{width:"550px", minHeight:"95vh"}} title="showCondition"/>
                </Modal.Body>
            </Modal>
        </div>    
    )
}

export default connect(null, actionsPolicy)(InitialDataView);
